var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket" },
    [
      _vm.ticketConfiguration
        ? _c(
            "div",
            { staticClass: "ticket__description" },
            [
              _c(
                "p",
                { staticClass: "ticket__descriptionTitle" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$tm(
                        _vm.ticketConfiguration.product,
                        "descriptionWebShop"
                      )
                    ) + "  \n        "
                  ),
                  _c("vvs", {
                    key: _vm.ticketConfiguration.id,
                    attrs: { "ticket-configuration": _vm.ticketConfiguration },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.checkoutView && _vm.productInfoText
                ? [_c("p", [_vm._v(_vm._s(_vm.productInfoText))])]
                : _vm._e(),
              _vm._v(" "),
              !_vm.isSubProduct
                ? [
                    _vm.checkoutView
                      ? [
                          _vm.checkoutView &&
                          _vm.ticketConfiguration.product.localPubTransIncluded
                            ? _c(
                                "p",
                                { staticClass: "ticket__descriptionSubtitle" },
                                [
                                  _vm._v(
                                    "\n            VVS: " +
                                      _vm._s(_vm.VVSInformation) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkoutView &&
                          _vm.ticketConfiguration.isRegistrationRequired &&
                          _vm.additionalOrderItemInformation &&
                          _vm.currentOrder &&
                          _vm.currentOrder.buyerData
                            ? _c(
                                "p",
                                { staticClass: "ticket__descriptionSubtitle" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.additionalOrderItemInformation
                                          .personalUse
                                          ? _vm.$t(
                                              "checkout.personalisation.personalUse"
                                            ) +
                                              ": " +
                                              _vm.currentOrder.buyerData
                                                .firstName +
                                              " " +
                                              _vm.currentOrder.buyerData
                                                .lastName
                                          : _vm.$t(
                                              "checkout.personalisation.hintNoTickets"
                                            )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : [
                          _vm.ticketConfiguration.event
                            ? _c(
                                "p",
                                { staticClass: "ticket__descriptionSubtitle" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("cart.cartItem.event")) +
                                      ": " +
                                      _vm._s(
                                        _vm.$tm(
                                          _vm.ticketConfiguration.event,
                                          "descriptionExternal"
                                        )
                                      ) +
                                      " (" +
                                      _vm._s(
                                        _vm._f("formatDateString")(
                                          _vm.ticketConfiguration.event
                                            .eventDateStart,
                                          _vm.userLanguage
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("formatDateString")(
                                          _vm.ticketConfiguration.event
                                            .eventDateEnd,
                                          _vm.userLanguage
                                        )
                                      ) +
                                      ")\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.client
                            ? _c(
                                "p",
                                { staticClass: "ticket__descriptionSubtitle" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("cart.cartItem.client")) +
                                      ": " +
                                      _vm._s(_vm.$tm(_vm.client, "title")) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                    _vm._v(" "),
                    _vm.productPromotion
                      ? _c("p", { staticClass: "ticket__descriptionReduced" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("cart.cartItem.promotionCode")) +
                              ": " +
                              _vm._s(_vm.productPromotion.code) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.checkoutView && !_vm.isSubProduct && !_vm.readonly
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "ticket__descriptionRemove",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.removeFromCart(_vm.ticketConfiguration)
                          },
                        },
                      },
                      [
                        _c("Trash"),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.links.removeArticle")) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ticket__mobileData" },
                [
                  _vm.ticketConfiguration.slot && !_vm.isSubProduct
                    ? [
                        _c("p", { staticClass: "ticket__slotText" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("formatTimeString")(
                                  _vm.ticketConfiguration.slot.printStart,
                                  _vm.userLanguage
                                )
                              ) +
                              " -\n            " +
                              _vm._s(
                                _vm._f("formatTimeString")(
                                  _vm.ticketConfiguration.slot.printEnd,
                                  _vm.userLanguage
                                )
                              ) +
                              " Uhr\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "ticket__slotText" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatDateString")(
                                    _vm.ticketConfiguration.slot.printStart,
                                    _vm.userLanguage
                                  )
                                ) +
                                "\n            "
                            ),
                            new Date(
                              _vm.ticketConfiguration.slot.printStart
                            ).getDate() !==
                            new Date(
                              _vm.ticketConfiguration.slot.printEnd
                            ).getDate()
                              ? [
                                  _vm._v(
                                    "\n              - " +
                                      _vm._s(
                                        _vm._f("formatDateString")(
                                          _vm.ticketConfiguration.slot.printEnd,
                                          _vm.userLanguage
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "ticket__amount" }, [
                    _vm._v(_vm._s(_vm.$t("cart.cartItem.quantity"))),
                  ]),
                  _vm._v(" "),
                  _vm.hideQuantityControls
                    ? [
                        _c("p", [
                          _vm._v(_vm._s(_vm.ticketConfiguration.quantity)),
                        ]),
                      ]
                    : [
                        _c(
                          "div",
                          { staticClass: "ticket__mobileAmountChange" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "ticket__amountChange",
                                attrs: { disabled: _vm.disableDecrease },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.decrementQuantity.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              –\n            ")]
                            ),
                            _vm._v(" "),
                            false
                              ? _c("span", {
                                  staticClass: "ticket__amountPlaceholder",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number.lazy",
                                  value: _vm.ticketConfiguration.quantity,
                                  expression: "ticketConfiguration.quantity",
                                  modifiers: { number: true, lazy: true },
                                },
                              ],
                              staticClass: "ticket__amountInput",
                              attrs: {
                                type: "number",
                                min: "0",
                                step: "1",
                                readonly:
                                  _vm.disableDecrease && _vm.disableIncrease,
                              },
                              domProps: {
                                value: _vm.ticketConfiguration.quantity,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    _vm.$set(
                                      _vm.ticketConfiguration,
                                      "quantity",
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  _vm.emitUpdateCart,
                                ],
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "ticket__amountChange ticketConfiguration__amountChange--add",
                                attrs: { disabled: _vm.disableIncrease },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.incrementQuantity.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              +\n            ")]
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ticketConfiguration
        ? _c(
            "div",
            { staticClass: "ticket__slot" },
            [
              _vm.ticketConfiguration.slot
                ? [
                    _c("p", { staticClass: "ticket__slotText" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("formatTimeString")(
                              _vm.ticketConfiguration.slot.printStart,
                              _vm.userLanguage
                            )
                          ) +
                          " -\n          " +
                          _vm._s(
                            _vm._f("formatTimeString")(
                              _vm.ticketConfiguration.slot.printEnd,
                              _vm.userLanguage
                            )
                          ) +
                          " Uhr\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "ticket__slotText" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDateString")(
                                _vm.ticketConfiguration.slot.printStart,
                                _vm.userLanguage
                              )
                            ) +
                            "\n          "
                        ),
                        new Date(
                          _vm.ticketConfiguration.slot.printStart
                        ).getDate() !==
                        new Date(
                          _vm.ticketConfiguration.slot.printEnd
                        ).getDate()
                          ? [
                              _vm._v(
                                "\n            - " +
                                  _vm._s(
                                    _vm._f("formatDateString")(
                                      _vm.ticketConfiguration.slot.printEnd,
                                      _vm.userLanguage
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ticketConfiguration
        ? _c(
            "div",
            { staticClass: "ticket__amount" },
            [
              _vm.hideQuantityControls
                ? [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.ticketConfiguration.quantity) +
                        "\n      "
                    ),
                  ]
                : [
                    _c(
                      "button",
                      {
                        staticClass: "ticket__amountChange",
                        attrs: { disabled: _vm.disableDecrease },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.decrementQuantity.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n          –\n        ")]
                    ),
                    _vm._v(" "),
                    false
                      ? _c("span", { staticClass: "ticket__amountPlaceholder" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number.lazy",
                          value: _vm.ticketConfiguration.quantity,
                          expression: "ticketConfiguration.quantity",
                          modifiers: { number: true, lazy: true },
                        },
                      ],
                      staticClass: "ticket__amountInput",
                      attrs: {
                        type: "number",
                        min: "0",
                        step: "1",
                        readonly: _vm.disableDecrease && _vm.disableIncrease,
                        disabled: _vm.disableIncrease && _vm.disableDecrease,
                      },
                      domProps: { value: _vm.ticketConfiguration.quantity },
                      on: {
                        change: function ($event) {
                          _vm.$set(
                            _vm.ticketConfiguration,
                            "quantity",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "ticket__amountChange ticketConfiguration__amountChange--add",
                        attrs: { disabled: _vm.disableIncrease },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.incrementQuantity.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n          +\n        ")]
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ticketConfiguration && !_vm.isSubProduct
        ? [
            _c(
              "div",
              { staticClass: "ticket__price" },
              [
                _vm.ticketConfiguration.specialProduct
                  ? [
                      _vm.productPromotion
                        ? [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "ticket__priceAmount ticket__priceAmount--reduced",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("formatPrice")(
                                        _vm.ticketConfiguration.product.price *
                                          _vm.ticketConfiguration.quantity
                                      )
                                    ) +
                                    " €\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "ticket__reducedPriceAmount" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("formatPrice")(
                                        _vm.productPromotion.price *
                                          _vm.ticketConfiguration.quantity
                                      )
                                    ) +
                                    " €\n            "
                                ),
                              ]
                            ),
                          ]
                        : [
                            _c("span", { staticClass: "ticket__priceAmount" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatPrice")(
                                    _vm.ticketConfiguration.product.price
                                  )
                                ) + " €"
                              ),
                            ]),
                          ],
                    ]
                  : [
                      _c("span", { staticClass: "ticket__priceAmount" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("formatPrice")(
                                _vm.ticketConfiguration.calculatedProductPrice *
                                  _vm.ticketConfiguration.quantity
                              )
                            ) +
                            " €\n          "
                        ),
                      ]),
                    ],
                _vm._v(" "),
                _c("span", { staticClass: "ticket__priceLabel" }, [
                  _vm._v(
                    "(" + _vm._s(_vm.$t("cart.cartItem.includingVat")) + ")"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ticket__mobileData" },
                  [
                    !_vm.readonly
                      ? [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                                title: _vm.$t("global.links.removeArticle"),
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeFromCart(
                                    _vm.ticketConfiguration
                                  )
                                },
                              },
                            },
                            [_c("Trash")],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }